$(document).ready(function() {
  $('.website_form_contact_project_name').toggle(false);
  $('.website_form_contact_project_name').find('input').removeAttr('required');

  $(document).on('change', '#website_form_contact_category', function() {
    const value = $('option:selected',this).val();
    $('.website_form_contact_project_name').toggle(value === 'ongoing_project' || value === 'donation_receipt');
    if (value === 'ongoing_project' || value === 'donation_receipt') {
      $('.website_form_contact_project_name').find('label').addClass('required');
      $('.website_form_contact_project_name').find('input').attr('required', true);
    } else {
      $('.website_form_contact_project_name').find('input').removeAttr('required');
    }
  });

  $('.inputfile').each(function() {
    const inputItem   = $(this);
    const labelItem   = inputItem.next('label');
    const labelVal    = labelItem.html();

    inputItem.on('change', function(e) {
      let fileName = '';

      if (this.files && this.files.length > 1) {
        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
      } else if (e.target.value) {
        fileName = e.target.value.split('\\').pop();
      }

      if (fileName) {
        labelItem.find('span').html(fileName);
      } else {
        labelItem.html(labelVal);
      }
    });

    // Firefox bug fix
    inputItem.on('focus', function() {
      inputItem.addClass('has-focus');
    }).on('blur', function() {
      inputItem.removeClass('has-focus');
    });
  });
});
